import { render } from "./SaveSystemUser.vue?vue&type=template&id=7e4cce62"
import script from "./SaveSystemUser.vue?vue&type=script&lang=js"
export * from "./SaveSystemUser.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__